
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 6C2.5 4.06728 4.06728 2.5 6 2.5H15.004C16.9347 2.5 18.5 4.06528 18.5 5.996V15.005C18.5 16.9346 16.9349 18.5 15.004 18.5H5.996C4.06528 18.5 2.5 16.9347 2.5 15.004V6ZM0.5 6C0.5 2.96272 2.96272 0.5 6 0.5H15.004C18.0393 0.5 20.5 2.96071 20.5 5.996V15.005C20.5 18.0394 18.0391 20.5 15.004 20.5H5.996C2.96071 20.5 0.5 18.0393 0.5 15.004V6ZM10.5 4.5C7.18672 4.5 4.5 7.18672 4.5 10.5C4.5 13.8133 7.18672 16.5 10.5 16.5C13.8133 16.5 16.5 13.8133 16.5 10.5C16.5 9.94772 16.0523 9.5 15.5 9.5H11.125C10.5727 9.5 10.125 9.94772 10.125 10.5C10.125 11.0523 10.5727 11.5 11.125 11.5H14.3739C13.9297 13.225 12.3634 14.5 10.5 14.5C8.29128 14.5 6.5 12.7087 6.5 10.5C6.5 8.29128 8.29128 6.5 10.5 6.5C11.4747 6.5 12.3648 6.84788 13.059 7.42757C13.4829 7.78156 14.1136 7.72488 14.4676 7.30097C14.8216 6.87705 14.7649 6.24643 14.341 5.89243C13.3012 5.02412 11.9613 4.5 10.5 4.5Z","fill":"currentColor"}})])
          )
        }
      }
    